'use client';

import CompanyContent from '@/components/company/CompanyContent';
import AboutUsContent from '@/content/company/en/about-us.mdx';

export default function AboutUsClient() {
    return (
        <CompanyContent>
            <AboutUsContent />
        </CompanyContent>
    );
}
